import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IUpgamingGetUrl, IUpgamingServerGame } from '../../types/interfaces/Slots/Upgaming';
import { ISlotConverter } from '../../types/converter';
import { getTab } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: { data: IUpgamingServerGame[] }): ISlotViewItem[] => {
    const desktopGames: ISlotViewItem[] = [];
    const mobileGames: ISlotViewItem[] = [];

    data.map((game: IUpgamingServerGame) => {
      const gameItem: ISlotViewItem = {
        id: game.id.toString(),
        gameId: game.gameId,
        description: game.gameName,
        provider: 'upgaming',
        gameName: game.gameName,
        routeProvider: 'upgaming',
        type: CasinoType.slots,
        tab: getTab(game.gameId),
        imageUrl: `https://fcdn.upgator.io/${game.cdnUrl}`,
      };

      if (game.gamePlatformTypeId === 1) {
        desktopGames.push(gameItem);
      } else if (game.gamePlatformTypeId === 2) {
        mobileGames.push(gameItem);
      }
    });

    return window.innerWidth <= 768 ? mobileGames : desktopGames;
  };

  convertGameUrl = ({ data }: IUpgamingGetUrl) => data.Content;
}
export default Converter;
